import React from "react";
 
import { changeSecondsToString } from "../../../hooks/useCountdown";

import styles from "./main-timer-display.module.scss";
import fonts from "./../../../../css/components/fonts.scss";

const MainTimerDisplay = ({ quarterParams }) => {
    return (
      <div className={`${styles['main-timer']} ${fonts.fs64}`}>
        {changeSecondsToString("timeLeft", quarterParams?.timeLeft)}
      </div>
    );
};


export default MainTimerDisplay;

    